import React, { useState } from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Copy, Check } from 'lucide-react';

interface RevealedLinkDisplayProps {
    link: string;
}

export function RevealedLinkDisplay({ link }: RevealedLinkDisplayProps) {
    const [copied, setCopied] = useState(false);
    
    return (
        <div className="px-4 pb-3 mt-2 pt-3" onClick={(e) => e.stopPropagation()}>
            <div className="space-y-2">
                <Label className="text-xs font-semibold text-gray-700">Generated Link:</Label>
                <div className="flex items-center gap-2 p-2 bg-white rounded border border-gray-200">
                    <Input
                        value={link}
                        readOnly
                        className="flex-1 font-mono text-xs h-8"
                    />
                    <Button
                        variant="outline"
                        size="sm"
                        onClick={async () => {
                            await navigator.clipboard.writeText(link);
                            setCopied(true);
                            setTimeout(() => setCopied(false), 2000);
                        }}
                        className="shrink-0 h-8 px-2"
                    >
                        {copied ? (
                            <>
                                <Check size={14} className="mr-1 text-confirm-action" />
                                Copied
                            </>
                        ) : (
                            <>
                                <Copy size={14} className="mr-1" />
                                Copy
                            </>
                        )}
                    </Button>
                </div>
            </div>
        </div>
    );
}


